import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { useAuthStatus } from "helpers/useAuthStatus";
import { useState } from "react";
import { ParentMetricsLoadingPage } from "./ParentMetricsPage";
import { SchoolMetricsLoadingPage } from "./SchoolMetrics";
import { StudentMetricsLoadingPage } from "./StudentMetricsPage";
// import React, { useCallback, useEffect, useState } from "react";
import { TeacherMetricsLoadingPage } from "./TeacherMetricsPage";

// To do: Fix: Switch by the role: Teacher/Parent
export const MetricsPage = (): JSX.Element => {
	const { role } = useAuthStatus();
	const [buttonName, setbuttonName] = useState("Teacher Metrics");
	const [metricsContent, setmetricsContent] = useState("");
	const handleButtonChange = (): void => {
		if (buttonName === "Teacher Metrics") {
			setbuttonName("School Metrics");
			setmetricsContent("Teacher Metrics");
		} else {
			setbuttonName("Teacher Metrics");
			setmetricsContent("School Metrics");
		}
	};
	// if (role === "student" || role === "parent") {
	if (role === "student") {
		return <StudentMetricsLoadingPage />;
	} else if (role === "parent") {
		return <ParentMetricsLoadingPage />;
	} else {
		return (
			<div>
				<Grid item xs={2}>
					<Stack direction="row" spacing={2}>
						<Button
							variant="contained"
							color="success"
							onClick={handleButtonChange}
						>
							{buttonName}
						</Button>
					</Stack>
				</Grid>
				{metricsContent === "Teacher Metrics" && <TeacherMetricsLoadingPage />}
				{metricsContent === "School Metrics" && <SchoolMetricsLoadingPage />}
			</div>
		);
	}

	// if (role === "teacher") {
	// 	return <TeacherMetricsPage />;
	// }
	// else {
	// 	// admin or school
	// 	return <SchoolMetricsPage />;
	// }
};
